import { render } from "./AnimatedBackground.vue?vue&type=template&id=66054258&scoped=true"
import script from "./AnimatedBackground.vue?vue&type=script&lang=js"
export * from "./AnimatedBackground.vue?vue&type=script&lang=js"

import "./AnimatedBackground.vue?vue&type=style&index=0&id=66054258&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66054258"],['__file',"src/scripts/sections/common/AnimatedBackground.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66054258"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66054258', __exports__)) {
    api.reload('66054258', __exports__)
  }
  
  module.hot.accept("./AnimatedBackground.vue?vue&type=template&id=66054258&scoped=true", () => {
    api.rerender('66054258', render)
  })

}


export default __exports__